import { z } from 'zod'
import { importCandidateActionSchema } from '../dto/event-import.dto.js'

/** Preview a legacy SVG import for one space of an event (1:1 phase↔space). */
export const previewEventImportInputSchema = z
  .object({
    venueSpaceId: z.string().uuid(),
    /** Full SVG dump from the legacy layout tool (may be large). */
    svg: z.string().min(20, 'Paste a full SVG').max(5_000_000, 'SVG is too large'),
  })
  .strict()

export type PreviewEventImportInput = z.infer<typeof previewEventImportInputSchema>

/** Per-candidate decision on apply (must cover every candidate from the preview). */
export const eventImportDecisionInputSchema = z
  .object({
    legacyKey: z.string().min(1).max(200),
    action: importCandidateActionSchema,
    /** Required when action is `match` for an item candidate. */
    furnitureItemId: z.string().uuid().optional(),
    /** Required when action is `match` for a group candidate. */
    furnitureGroupId: z.string().uuid().optional(),
  })
  .strict()

export type EventImportDecisionInput = z.infer<typeof eventImportDecisionInputSchema>

/**
 * Apply a legacy SVG import: create/match catalog rows, top up inventory, and
 * replace the phase plan for the space with the parsed placements.
 */
export const applyEventImportInputSchema = z
  .object({
    venueSpaceId: z.string().uuid(),
    svg: z.string().min(20).max(5_000_000),
    decisions: z.array(eventImportDecisionInputSchema).min(1),
  })
  .strict()

export type ApplyEventImportInput = z.infer<typeof applyEventImportInputSchema>
